<template>
  <div class="mainArea overflowHidden">
    <div ref="square" class="square">
      <div class="positionAbsolute center t10 l50 h20 w20 cloud3">
        <img :src="img['cloudB']" class="absoluteContainer h100"/>
      </div>

      <div class="positionAbsolute center t15 l50 h40 w40 cloud2">
        <img :src="img['cloudA']" class="absoluteContainer h100"/>
      </div>

      <div class="positionAbsolute center t18 l50 h60 w60 cloud1">
        <img :src="img['cloudA']" class="absoluteContainer h100"/>
      </div>

      <div class="positionAbsolute center t90 l105 h30 w30 slime">
        <img :src="img['slime1']" class="absoluteContainer h100" v-show="slimeStage == 0"/>
        <img :src="img['slime2']" class="absoluteContainer h100" v-show="slimeStage == 1"/>
        <img :src="img['slime3']" class="absoluteContainer h100" v-show="slimeStage == 2"/>
        <img :src="img['slime4']" class="absoluteContainer h100" v-show="slimeStage == 3"/>
        <img :src="img['slime5']" class="absoluteContainer h100" v-show="slimeStage == 4"/>
      </div>

      <div class="positionAbsolute center t40 l30 h100 w200 titleArea">
        <div class="absoluteCenter w100 textCenter">
          <div :style="'font-size : ' + $refs.square.offsetHeight / 100 * 14 +  'px'" v-if="$refs.square">Ivan Ho</div>
          <div :style="'font-size : ' + $refs.square.offsetHeight / 100 * 5.3 +  'px'" v-if="$refs.square">Multimedia Developer</div>
        </div>
      </div>
      
      <div class="positionAbsolute center t65 l90 h80 avatarArea">
        <img class="absoluteCenter h100" :src="img['ivanIdleA']" v-show="idleStage == 0 && !isShowIvanLike"/>
        <img class="absoluteCenter h100" :src="img['ivanIdleB']" v-show="idleStage == 1 && !isShowIvanLike"/>
        <img class="absoluteCenter h100" :src="img['ivanLike']" v-show="isShowIvanLike"/>
      </div>

      <div class="positionAbsolute center t80 l120 h12 w12 linkedInArea touch hoverCursorPointer" @click="openLinkedIn()">
        <img :src="img['linkedIn']" class="absoluteCenter h100 floating1"/>
      </div>

      <div class="positionAbsolute center t75 l30 h12 w60 infoBox overflowHidden emailArea touch hoverCursorPointer" @click="OnClickCopyEmail()">
        <div class="positionRelative t0 l0 h100 w80 floatLeft">
          <div class="absoluteCenter w80"
            :style="'font-size : ' + $refs.square.offsetHeight / 100 * 4 +  'px'" v-if="$refs.square"
          >
            ivanho521@gmail.com
          </div>
        </div>
        <div class="positionRelative t0 l0 h100 w20 floatLeft">
          <img :src="img['copyIconBlack']" class="absoluteCenter h50"/>
        </div>
        <transition name="fade">
          <div class="positionAbsolute t0 l0 h100 w100 copied" v-show="isShowEmailCopied">
            <div class="absoluteCenter w100 textCenter">Copied</div>
          </div>
        </transition>
        
      </div>

      <div class="positionAbsolute center t90 l30 h12 w60 infoBox phoneArea overflowHidden touch hoverCursorPointer" @click="OnClickCopyPhone()">
        <div class="positionRelative t0 l0 h100 w80 floatLeft">
          <div class="absoluteCenter w80"
            :style="'font-size : ' + $refs.square.offsetHeight / 100 * 4 +  'px'" v-if="$refs.square"
          >
            +852 93005356
          </div>
        </div>
        <div class="positionRelative t0 l0 h100 w20 floatLeft">
          <img :src="img['copyIconBlack']" class="absoluteCenter h50"/>
        </div>
        <transition name="fade">
          <div class="positionAbsolute t0 l0 h100 w100 copied" v-show="isShowPhoneCopied">
            <div class="absoluteCenter w100 textCenter">Copied</div>
          </div>
        </transition>
        
      </div>

    </div>

    <transition name="fade">
      <div class="absoluteCenter h100 w100 bgBlack" v-show="!isLoadingFinished">
        <div class="square">
          <div class="positionAbsolute center t65 l90 h80 avatarArea">
            <img class="absoluteCenter h100" :src="img['ivanWhite']"/>
          </div>

          <div class="absoluteCenter loaderArea">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </transition>
    

  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '@/store'

export default {
  name: 'homeMain',
  data () {
    return {
      language : i18n.locale,
      img : {
        ivan512 : "static/images/home/ivan512.webp",

        copyIconBlack : "static/images/icon/copyBlack.webp",

        ivanIdleA : "static/images/home/ivanIdleA.webp",
        ivanIdleB : "static/images/home/ivanIdleB.webp",
        ivanLike : "static/images/home/ivanLike.webp",
        // ivanWhite : "static/images/home/ivanWhite.webp",
        ivanWhite : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAAAM1BMVEX////////////////////////////////////////////////////////////////////lEOhHAAAAEXRSTlMAAgED/xcKBu0aIwcVBQgEE5+10+wAAAPTSURBVHgB7d2F1uJADIDRtGRd3/9p92Tdf7TTTO89jkM+HKYBAAAAAAAAAAAAAAAAAAAAAAAAAAAAW1u+W79bvot5IQAEwKmcsQcCQAAIAAHMi/wuZoQAEAACQADkf0WZrQUEgAAQAAIgzxUIAAEggJ4QAAIgy5mj718BAkAACAABkPcULSAABIAAEAB5d4EAEAACQAD9+ey3fwUIAAEgAARAbiIQAAJAAAigAbPvXwECQAAIAAEgAASAABAAAiCHCASAABAAAkAAgzFZBQgAASAABIAAEAACQAAIAAEgAASAABAAOU4gAASAABAA3gUgAASAABAA3gUgAASAABAAAkAACAABIAAsF4oAEAACQAAIAAEgAASAABAAAkAACAABIAD2VkEgAASAABAAh6ogEAACQAAIgENVEAgAASAABNACZn9AAkAACAABcCp5k7UEAkAACAABNMdML/gRAAJAAAgAASAABIAAEAACoNWvghEAAkAACADrAyAABIAAEABWCkUACAABIABsMwgBIAAEgADIYQIBIAAEgAAYP/rWGSAABIAAEAACQAAIAAEgAASAABAAAkAACIDcmUAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAGweQANKkAACAABIAAEgAAQAAJAAORuBQJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABYGkABIAAEAACwIYjEQACQAAIAAEgAASAABAAAkAAOyEABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACIBnJf/mecm7+3dxL0ogAASAABAAG8nPXpbc2E9nGggAASAABMBGlpK7sJZAAAgAASAANvLqsxzm1WeBABAAAkAACGAsXpe8uzclEAACQAAIgH16W/IM78pa/AGsOwEgAASAAHhf8gxreVe6B4AAEAACQACcPdJ35UPpHgACQAAIAAFwKnmG03fdA0AACAABIADWMnkACAABIAAEgAAQAAJAAAiApVw2UuuBnkkACAABIAAEgAAQAAJAAAgAASAABIAAEMBkBBAIAAEgAATA3nUOAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABMDHkuWGANpUgAAQAAJAAKxlKQI4BgEgAASAABAAa4kigOMQAAJAAAig8L7MHQACQAAIAAGQN7nb6SAABIAAEAB9AljKsAAQAAJAAAgAASAABIAAEAA+CkYACAABIAAEgAAQAAJAAAAAAAAAAAAAAAAAAACfAK6/4cuvse3SAAAAAElFTkSuQmCC",

        cloudA : "static/images/home/cloud1.webp",
        cloudB : "static/images/home/cloud2.webp",

        tree : "static/images/home/tree.webp",

        slime1 : "static/images/home/slime1.webp",
        slime2 : "static/images/home/slime2.webp",
        slime3 : "static/images/home/slime3.webp",
        slime4 : "static/images/home/slime4.webp",
        slime5 : "static/images/home/slime5.webp",

        linkedIn : "static/images/icon/linkedIn.webp",
        ig : "static/images/icon/ig.webp",

      },

      isLoadingFinished : store.state.isLoadingFinished,

      idleStage : 0,

      slimeStage : 0,
      
      isShowIvanLike : false,

      isShowEmailCopied : false,
      isShowPhoneCopied : false,

      isCopying : false,


      idleInterval : null,
      slimeInterval : null,

      

    }
  },
  created(){
   
  },
  mounted(){
    this.startIdleAnimation();
    this.startSlimeAnimation();
  },

  methods:{

    startIdleAnimation(){
      let self = this;
      this.idleInterval = setInterval(() => {
        self.idleStage = self.idleStage == 0 ? 1 : 0;
      }, 300);
    },

    startSlimeAnimation(){
      let self = this;
      this.slimeInterval = setInterval(() => {
        self.slimeStage = self.slimeStage == 4 ? 0 : self.slimeStage + 1;
      }, 50);
    },

    OnClickCopyEmail(){
      let self = this;
      if(self.isCopying){
        return;
      }
      self.isCopying = true;
      this.isShowEmailCopied = true;
      self.isShowIvanLike = true;
      const el = document.createElement('textarea');
      el.value = "ivanho521@gmail.com";
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      setTimeout(function(){
        self.isShowEmailCopied = false;
        self.isShowIvanLike = false;
        self.isCopying = false;
      },1000)
    },

    OnClickCopyPhone(){
      let self = this;
      if(self.isCopying){
        return;
      }
      self.isCopying = true;
      this.isShowPhoneCopied = true;
      self.isShowIvanLike = true;
      const el = document.createElement('textarea');
      el.value = "93005356";
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      setTimeout(function(){
        self.isShowPhoneCopied = false;
        self.isShowIvanLike = false;
        self.isCopying = false;
      },1000)
    },

    openLinkedIn(){
      window.open('https://www.linkedin.com/in/ivanho521','_blank');
      if(store.state.isGAEvent){
        gtag('event', 'openLinkedIn', {'event_callback': function() {}});
      }
    },

  },

  BeforeUnloadEvent(){
    console.log("leave");
  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkIsLoadingFinished(){return store.state.isLoadingFinished},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
    checkIsLoadingFinished(flag){this.isLoadingFinished = flag},
  },
}
</script>

<style scoped>

.mainArea{
  position: relative;
  width: 100%;
  height: calc(100% - 10vh);
  /* margin-top: 5em; */
  background-color: #73c1ec;
}

.name{
  font-size: 100%;
}

.title{
  font-size: 100%;
}

.infoBox{
  border-radius: 2vh;
  color: #211813;
  font-size: 3vh;
  background-color: #f5e54d;
}

.copied{
  color: white;
  background-color: #000000;
}


.loader {
  width: 10vh;
  aspect-ratio: 4;
  --_g: no-repeat radial-gradient(circle closest-side,#FFF 90%,#0000);
  background: 
    var(--_g) 0%   50%,
    var(--_g) 50%  50%,
    var(--_g) 100% 50%;
  background-size: calc(100%/3) 100%;
  animation: l7 1s infinite linear;
}
@keyframes l7 {
    33%{background-size:calc(100%/3) 0%  ,calc(100%/3) 100%,calc(100%/3) 100%}
    50%{background-size:calc(100%/3) 100%,calc(100%/3) 0%  ,calc(100%/3) 100%}
    66%{background-size:calc(100%/3) 100%,calc(100%/3) 100%,calc(100%/3) 0%  }
}

@keyframes cloundAnimation{
  0% {left: -50% ; opacity: 0}
  5% {opacity: 1}
  95% {opacity: 1}
  100% {left: 150% ; opacity: 0}
}

.cloud1{
  opacity: 0;
  animation-name: cloundAnimation;
  animation-duration: 25s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-delay: 10s;
}

.cloud2{
  opacity: 0;
  animation-name: cloundAnimation;
  animation-duration: 55s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-delay: 5s;
}

.cloud3{
  opacity: 0;
  animation-name: cloundAnimation;
  animation-duration: 50s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-delay: 0s;
}

@media (max-aspect-ratio: 4/3) {
  .titleArea{
    top: 15%;
    left: 50%;
    transform: translate(-50%,-50%) scale(0.7);
  }

  .avatarArea{
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%) scale(0.6);
  }

  .slime{
    left: 60%;
    top: 66%;
    transform: translate(-50%,-50%) scale(0.6);
  }

  .linkedInArea{
    left: 35%;
    top: 60%;
    transform: translate(-50%,-50%) scale(0.6);
  }

  .igArea{
    left: 35%;
    top: 60%;
    transform: translate(-50%,-50%) scale(0.6);
  }

  .emailArea{
    left: 50%;
    top: 76%;
    transform: translate(-50%,-50%) scale(0.7);
  }

  .phoneArea{
    left: 50%;
    top: 86%;
    transform: translate(-50%,-50%) scale(0.7);
  }

  @keyframes cloundAnimation{
    0% {left: 20% ; opacity: 0}
    5% {opacity: 1}
    95% {opacity: 1}
    100% {left: 80% ; opacity: 0}
  }

  .cloud1{
    top: 85%;
    width: 80%;
    height: 80%;
    animation-duration: 30s;
  }

  .cloud2{
    top: 40%;
    width: 30%;
    height: 30%;
    animation-duration: 40s;
  }

  .cloud3{
    top: 30%;
    width: 15%;
    height: 15%;
    animation-duration: 70s;
  }

  .loaderArea{
    top:80%;
  }

}






</style>



// WEBPACK FOOTER //
// src/components/homeMain.vue